export enum StsCaptchaType {
    text = 'text',
    recaptcha = 'recaptcha'
}
